import * as React from 'react';
import { Button, StyleSheet, TextInput, View, Pressable, Image } from 'react-native'

import api from "../../utils/api"
import tw from '../../styles/tailwind';
import Text from '../../components/Text';
import Icon from '../../components/Icon';

import HeaderCompletaPagoSucursal from './HeaderPagoSucursal';
import FormaCompletaPagoSucursal from './FormaPagoSucursal';

export default function CompletaPagoEfectivoScreen({navigation}) {
  

  return (
    <View style={tw`bg-white flex-1`}>
      <HeaderCompletaPagoSucursal navigation={navigation} />
      <FormaCompletaPagoSucursal navigation={navigation} />
    </View>
  );
}